import { createStyles, makeStyles } from '@hawkins/styles';
export function dateTimePickerInputStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the `Card`. */
        card: {},
        /** Class name of the end adornment icon. */
        endAdornmentIcon: {
            cursor: 'pointer',
        },
        /** Class name of the `FloatingUI`. */
        floatingUI: {
            zIndex: hawkinsVariables.zIndexes.dropdown,
        },
        /** Class name of the root element. */
        root: {},
        /** Class name of the start adornment icon. */
        startAdornmentIcon: {
            cursor: 'pointer',
            marginTop: 1,
        },
        /** Class name of the start adornment icon when the component is disabled. */
        startAdornmentIconDisabled: {
            cursor: 'not-allowed',
        },
    });
}
export var useDateTimePickerInputStyles = makeStyles(dateTimePickerInputStyles, {
    name: 'Hawkins-DateTimePickerInput',
});
